import {
  defaultSystemCode,
  defaultTrader,
  exists,
  SystemCode,
  SystemCodeFromJSON,
  Trader
} from '@/api'
import { BibliographyClass, CollectionFlag, Prefix } from '@/types'
import { dateToPlainFormat } from '@/utils'
import { traderStore } from '@/utils/store-accessor'

export interface OfficialAcceptCollection {
  id: number
  collectionNo: string
  publishDate: string
  bibliographyId: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  searchType: SystemCode
  displayTitle: string
  status: SystemCode
  collectionType: SystemCode
  handlingType: SystemCode
  appendixCode: SystemCode
  acceptType: SystemCode
  holdingBranchCode: SystemCode
  shelfType: SystemCode
  mark: string
  ndc: string
  book: string
  sub: string
  acceptDate: string
  acceptPrice: number
  traderCode: Trader
  hasReserve: boolean
  collectionFlag: CollectionFlag
  revision: number
  _reserveAssign?: boolean
}

export function OfficialAcceptCollectionFromJSON(
  json: any
): OfficialAcceptCollection {
  return {
    id: exists(json, 'id') ? json.id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    publishDate: exists(json, 'publish_date')
      ? dateToPlainFormat(json.publish_date)
      : '',
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    status: exists(json, 'status')
      ? SystemCodeFromJSON(json.status)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    appendixCode: exists(json, 'appendix_code')
      ? SystemCodeFromJSON(json.appendix_code)
      : defaultSystemCode(),
    acceptType: exists(json, 'accept_type')
      ? SystemCodeFromJSON(json.accept_type)
      : defaultSystemCode(),
    holdingBranchCode: exists(json, 'holding_branch_code')
      ? SystemCodeFromJSON(json.holding_branch_code)
      : defaultSystemCode(),
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    mark: exists(json, 'mark') ? json.mark : '',
    ndc: exists(json, 'ndc') ? json.ndc : '',
    book: exists(json, 'book') ? json.book : '',
    sub: exists(json, 'sub') ? json.sub : '',
    acceptDate: exists(json, 'accept_date')
      ? dateToPlainFormat(json.accept_date)
      : '',
    acceptPrice: exists(json, 'accept_price') ? json.accept_price : '',
    traderCode:
      exists(json, 'trader_code') && traderStore.findByCode(json.trader_code)
        ? ({ ...traderStore.findByCode(json.trader_code) } as Trader)
        : defaultTrader(),
    hasReserve: exists(json, 'has_reserve') ? json.has_reserve : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    revision: exists(json, 'revision') ? json.revision : '',
    _reserveAssign: undefined
  }
}
